import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import './style.css';

const WorkdaysPage: React.FC = () => {
  const { language } = useLanguage();
  const t = (key: any) => translate(key, language as 'en' | 'ua');

  return (
    <div className="workdays-page">
      <h1>{t('pages.workdays.title')}</h1>
      <p>{t('pages.workdays.description')}</p>
      {/* TODO: Implement workdays settings */}
    </div>
  );
};

export default WorkdaysPage;
